import React from 'react';
import { blogContentParser } from '../../../../utils/helpers';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useSelector } from 'react-redux';
import FolderSkeleton from '../../../../ui-core/Skeletons/FolderSkeleton';
import './style.css';
import dayjs from 'dayjs';
const TopEpisodes = () => {
  const history = useHistory();
  const { spotLight } = useSelector(state => state.podcasts);
  const renderSkeletons = [1, 2, 3].map(item => <FolderSkeleton key={item} />);

  return (
    <>
      {!spotLight?.length && (
        <div className="top-episodes">{renderSkeletons}</div>
      )}
      {spotLight?.length &&
        spotLight.slice(0, 5).map(spotlightItem => (
          <div
            onClick={() =>
              history.push(`/podcast/${spotlightItem?.attributes?.episode}`)
            }
            className="top-episodes"
            key={spotlightItem.id}
          >
            <div className="d-flex justify-content-between">
              <span className="ct-name">
                EPISODE {spotlightItem?.attributes?.episode}
              </span>
              <span className="views">
                {/* <img src={IMAGE_CONSTANT.eyeIcon} alt="" /> */}
                {dayjs(
                  spotlightItem?.attributes?.podcastLiveDate ||
                    spotlightItem?.attributes?.createdAt,
                ).format('MMM D, YYYY')}
              </span>
            </div>
            <div className="image-hidden">
              {Object.keys(spotlightItem).length > 0 &&
                blogContentParser(spotlightItem?.attributes?.summary).slice(
                  0,
                  50,
                )}
              ...
            </div>
          </div>
        ))}
    </>
  );
};

export default TopEpisodes;
